import { useState, useEffect } from "react"

interface Props {
	data: {
		estado?: string
	}
}

export const PercentageBar = ({ data }: Props) => {
	const [percentage, setPercentage] = useState(0)
	const [color, setColor] = useState("#ddd")

	useEffect(() => {
		switch (data?.estado) {
			case "Completando formulario de registro":
				setPercentage(10)
				setColor("#ff3300")
				break
			case "Usuario corrigiendo errores":
				setPercentage(20)
				setColor("#ff3300")
				break
			case "Evaluación de solicitud":
				setPercentage(30)
				setColor("#ff3300")
				break
			case "Asignación de Inspector":
				setPercentage(40)
				setColor("#ffcc00")
				break
			case "Inspección":
				setPercentage(50)
				setColor("#ffcc00")
				break
			case "Tasación":
				setPercentage(60)
				setColor("#ff9900")
				break
			case "Pendiente de pago tasación":
				setPercentage(80)
				setColor("#ff9900")
				break
			case "Enviado a sala capitular":
				setPercentage(90)
				setColor("#ff9900")
				break
			case "Emisión de Certificado":
				setPercentage(100)
				setColor("#00cc00")
				break
			default:
				setPercentage(0)
				setColor("#ddd")
				break
		}
	}, [data?.estado])

	return (
		<div className="relative w-full h-4 bg-gray-200 rounded-full">
			<div
				className="absolute top-0 left-0 h-full rounded-full"
				style={{ width: `${percentage}%`, backgroundColor: color }}
			></div>
		</div>
	)
}
